import { ImpactType } from '../../impact';

export interface CawSampleProject {
  projectId: number;
  name: string;
  slug: string;
  imageUrl: string;
  impactType: ImpactType;
}
